import Skeleton from "react-loading-skeleton";
import React from "react";

// Mirrors PlayerStatistic.js's own merged tournament-card + match table
// shape (same .player-statistic-card/.player-statistic-wrapper nesting, see
// that file's own comment on why the wrapper's border is switched off) -
// otherwise the skeleton and the real content would visibly jump layout
// the moment data arrives.
export const StatisticLazyLoad = ({ grade = 2, count = 3 }) => {
    return (
        <div className="sidebar-wrapper statistic">
            {Array.from({ length: 2 }).map((_, tableIndex) => (
                <div className="tournament-card player-statistic-card" key={tableIndex} style={{ pointerEvents: "none" }}>
                    <div className="tournament-card-date" style={{ border: "none", background: "transparent", padding: 0 }}>
                        <Skeleton width={56} height={16} borderRadius={20} />
                    </div>
                    <div className="tournament-card-top">
                        <div className="tournament-card-thumb" style={{ background: "transparent" }}>
                            <Skeleton circle width={36} height={36} />
                        </div>
                        <div className="tournament-card-titles" style={{ flex: 1, minWidth: 0 }}>
                            <div className="tournament-card-title"><Skeleton width="65%" height={16} /></div>
                            <div className="tournament-card-club"><Skeleton width="40%" height={13} style={{ marginTop: 4 }} /></div>
                            <div className="tournament-card-info"><Skeleton width="50%" height={11} style={{ marginTop: 4 }} /></div>
                        </div>
                    </div>
                        <table className="groups-table statistic player-statistic-wrapper" style={{ tableLayout: "fixed" }}>
                            <colgroup>
                                <col style={{width: "40px"}} />
                                <col />
                                <col  style={{width: "50px"}} />
                                <col />
                            </colgroup>
                            <tbody>
                                {Array.from({ length: count }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td>
                                            <Skeleton width={20} height={14} />
                                        </td>
                                        <td>
                                            <Skeleton width={grade === 1 ? 70 : 110} height={14} />
                                            {grade === 1 && <><br /><Skeleton width={70} height={14} style={{ marginTop: "4px" }} /></>}
                                        </td>
                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            <Skeleton width={20} height={18} />
                                        </td>
                                        <td>
                                            <Skeleton width={grade === 1 ? 70 : 110} height={14} />
                                            {grade === 1 && <><br /><Skeleton width={70} height={14} style={{ marginTop: "4px" }} /></>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                </div>
            ))}
        </div>
    );
};
